import config from "../config";
import {httpGet, httpPost} from "./http-functions";
import {OrgUnitAdmin, OrgUnitPermission} from "../models/admin-permission.models";
import {OrgUnit} from "../models/organization";


export const upsertAdmin = async (organizationId: number, admin: any) => {
    const resp = await httpPost(`${config.api}/organizations/${organizationId}/admins`, admin);
    return resp.data;
};

export const getAdmins = async (organizationId: number) => {
    const resp = await httpGet(`${config.api}/organizations/${organizationId}/admins`);
    return resp.data;
}

export const getAdminPermissions = async (organizationId: number, adminId: string, {
    organizationUnitId,
    organizationUnitParentId
}: { organizationUnitId?: number, organizationUnitParentId?: number }): Promise<OrgUnitAdmin> => {
    const resp = await httpGet(`${config.api}/organizations/${organizationId}/admins/${adminId}?organizationUnitId=${organizationUnitId}&organizationUnitParentId=${organizationUnitParentId}`);
    return resp.data;
};

export const getMultipleUnitsAdminPermissions = async (organizationId: number, adminId: string, units: OrgUnit[]) => {
    const unitPermissions = await Promise.all(units.map((unit: any) => getAdminPermissions(organizationId, adminId, {organizationUnitId: unit.id})));
    return unitPermissions.reduce((acc, curr) => ({
           ...acc,
        ...curr,
        permissions: [
            ...acc.permissions,
            ...curr.permissions
        ]
    }), {permissions: [] as OrgUnitPermission[]});
}